import React, { useState } from "react";
import {Collapse} from "react-collapse"
import navigationEventTracker from "../tracker/navigationEventTracker";


const LanguageTab = ({ label, iconClass, subTabs, hideOnWeb, trackingInfo }) => {

  const [expand, setExpand] = useState(false);


  const toggleExpand = () => {
    navigationEventTracker(trackingInfo);
    setExpand(!expand);
  };

  return (
    <div className={`${hideOnWeb ?  getDisplayOptions.hiddenOnWeb : ""}`}>
      <div tabIndex={0} role="button" aria-expanded={expand ? true: false} className="navitem cjs_navigation_header" onClick={toggleExpand}>
          <i   className={`fa-regular ${iconClass}`}></i>
          <div className="nav-title"> {label} </div>
          <i   className={`fa-regular ${ expand ? "fa-angle-up" : "fa-angle-down" } expand-icon`} ></i>
      </div>
      <Collapse isOpened={expand} className={`subnav`}>
        {subTabs.map((subNav, index) => (
          <OtherLanguages key={index} expand={expand} subNav={subNav} />
        ))}
      </Collapse>
    </div>
  );
};

const OtherLanguages = ({ subNav, expand }) => {

  return (
    <div className={`subnav-item ${subNav.active ? "navitem-active" : ""}`} >
      <a tabIndex={expand ? 0 : -1 } onClick= {()=> { navigationEventTracker(subNav.trackingInfo) }} title={subNav.label} href={subNav.url} rel="nofollow" data-method="patch"> {subNav.label} </a>
    </div>
)};

export default LanguageTab;
